export default __webpack_public_path__ + "static/media/link_to_app_image.2c54276c.jpg";